// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".floating-container[data-v-0b06fe38]{position:fixed;right:0;top:0}#app.xs .floating-container[data-v-0b06fe38]{right:0}#app.ios .floating-container[data-v-0b06fe38]{top:env(safe-area-inset-top)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
